import React from 'react';
import classNames from 'classnames/bind';
import errorBoundary from '@ifeng-fe/errorBoundary';
import { formatImageWebpAuto } from '@ifeng-fe/public_method';
import { WxLaunchHack } from '@ifeng-fe/three_terminal/es/mobile/wxLaunchHack/dynamic';
import { volcengineAndH5Statistics } from '@ifeng-fe/mobile_statistics';
import type { ImageModel } from '@src/utils/formatImage';
import type { CommentItem } from '@src/services/commentApi';
import Pics from '@src/mobile/components/pics';
import Labels from '@src/mobile/components/Labels';
import { getQuery, jumpPageUrl } from '@src/utils';
import styles from './index.css';

const cx = classNames.bind({ ...styles });

type AllData = {
    content: {
        data: CommentItem;
        authorId?: string | null;
        pageId: string;
    };
};

const Item: React.FC<AllData> = ({ content }) => {
    const { data, authorId, pageId } = content;
    const {
        faceurl,
        uname,
        user_id = '',
        uptimes,
        user_label = [],
        comment_contents = '',
        pics = [],
        ip_from = '',
        comment_date = '',
    } = data;
    const userId = getQuery(window.location.href, 'userId') || '';

    const handleUserClick = () => {
        volcengineAndH5Statistics({
            behavior: 'action',
            type: 'sharepage_link_button',
            button_name: 'a',
            user_id: userId,
        });
        jumpPageUrl('personal', user_id);
    };
    const callAppDataG = {
        docType: 'flutter',
        pid: `/detail?id=${pageId}&ref=outside`,
        noKindFrom: 1,
        kind: 'inter_txs06',
        download: 'https://a.app.qq.com/o/simple.jsp?pkgname=com.ifeng.news2&ckey=CK1394731469274',
        downloadAd: 'https://statistics.appstore.ifeng.com/index.php/api/godownload?app_id=4&d_ch=8992',
    };

    const callAppDataH = {
        docType: 'flutter',
        pid: `/detail?id=${pageId}&ref=outside`,
        noKindFrom: 1,
        kind: 'inter_txs07',
        download: 'https://a.app.qq.com/o/simple.jsp?pkgname=com.ifeng.news2&ckey=CK1394471921886',
        downloadAd: 'https://statistics.appstore.ifeng.com/index.php/api/godownload?app_id=4&d_ch=8993',
    };

    const wxLaunchHackDataG = {
        callAppConfig: callAppDataG,
        statisticsConfig: {
            behavior: 'action',
            type: 'sharepage_app_start',
            button_name: 'g',
            user_id: userId,
        },
    };
    const wxLaunchHackDataH = {
        callAppConfig: callAppDataH,
        statisticsConfig: {
            behavior: 'action',
            type: 'sharepage_app_start',
            button_name: 'h',
            user_id: userId,
        },
    };

    return (
        <div className={styles.item}>
            <div className={styles.topBox}>
                <div className={styles.left}>
                    <div className={styles.avatarWrap} onClick={handleUserClick}>
                        <img className={styles.avatar} src={formatImageWebpAuto(faceurl, 76, 76)} alt="" />
                    </div>
                </div>
                <div className={styles.right}>
                    <div className={styles.userBox}>
                        <div className={styles.userInfo}>
                            <div className={styles.user}>
                                <div className={styles.userName} onClick={handleUserClick}>
                                    {uname}
                                </div>
                                {authorId === user_id ? (
                                    <>
                                        <div className={styles.userLine} />
                                        <div className={styles.userAuthor}>作者</div>
                                    </>
                                ) : null}
                            </div>
                            <Labels content={{ list: user_label, itemClass: styles.userLabelItem }} />
                        </div>
                        <div className={styles.like}>
                            <div className={styles.likeNum}>
                                {typeof uptimes === 'number' && uptimes > 0 ? uptimes : '赞'}
                            </div>
                            <div className={styles.likeIcon} />
                            <WxLaunchHack content={wxLaunchHackDataG} />
                        </div>
                    </div>
                </div>
            </div>
            <div className={styles.bottomBox}>
                <div className={styles.left} />
                <div className={cx('right', 'rightBottomBox', { rightHasLabel: !!user_label.length })}>
                    {comment_contents ? <div className={styles.text}>{comment_contents}</div> : null}
                    {pics && Array.isArray(pics) && pics.length ? (
                        <div className={cx('pics', { picsNoText: !comment_contents })}>
                            <Pics content={{ list: pics as ImageModel[], isComment: true }} />
                        </div>
                    ) : null}
                    <div className={styles.menu}>
                        <div className={styles.info}>
                            <div className={styles.location}>{ip_from}</div>
                            {ip_from && comment_date ? <div className={styles.line} /> : null}
                            <div className={styles.time}>{comment_date}</div>
                        </div>
                        <div className={styles.reply}>
                            <div>回复</div>
                            <WxLaunchHack content={wxLaunchHackDataH} />
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default errorBoundary(Item);
